
<div class="grid-progess-renderer">
  <ds-progress-bar [progressBarInput]="progressConfig"></ds-progress-bar>
  @if(isPrgressValue){<span>{{progressConfig.progressValue}} %</span>}
</div>